module.exports = __webpack_public_path__ + "img/processandopgto.4f838754.svg";